<style lang="scss" scoped>
.md-card-content:last-of-type {
  padding-bottom: 0px;
}

.md-card .md-card-content {
  padding: 0px 15px;
  line-height: 1.75em;
  position: relative;
}

.md-field.md-focused label,
.md-field.md-has-value label,
.md-field.md-focused.md-has-value label {
  color: #6d6d6dab !important;
  font-weight: bold;
  font-size: 1.4rem;
}

.md-field.md-focused label,
.md-field.md-field.md-has-value label {
  top: -1rem;
}
</style>

<template>
  <div>
    <md-card>
      <md-card-content class="md-layout md-gutter">
        <div
          class="md-layout-item md-layout md-size-20 md-medium-size-40 md-small-size-40 md-xsmall-size-100"
        >
          <div class="md-layout-item md-layout md-size-100">
            <md-field>
              <label for="stateS">Estado</label>
              <md-select v-model="stateS" name="stateS" id="stateS">
                <md-option :value="0">Sin Filtro</md-option>
                <md-option :value="c.id" v-for="c in mStates" :key="c.id">{{c.name}}</md-option>
              </md-select>
            </md-field>
          </div>
        </div>

        <div
          class="md-layout-item md-layout md-size-20 md-medium-size-40 md-small-size-40 md-xsmall-size-100"
        >
          <div class="md-layout-item md-layout md-size-100">
            <md-field>
              <label for="highwayS">Autopista</label>
              <md-select v-model="highwayS" name="highwayS" id="highwayS">
                <md-option :value="0">Sin Filtro</md-option>
                <md-option :value="h.id" v-for="h in mHighways" :key="h.id">{{h.name}}</md-option>
              </md-select>
            </md-field>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import { Slider, Collapse } from "@/components";
import dataService from "../../../services/catalog";

export default {
  components: {
    Slider,
    Collapse,
  },
  data() {
    return {
      responsive: false,
      // selected
      highwayS: 0,
      stateS: 0,
      // metadatas
      mHighways: [],
      mStates: [],

      filterFunctions: [],
    };
  },
  props: {
    datasIn: Array,
  },
  methods: {
    registerFilter(filterFunction) {
      this.filterFunctions.push(filterFunction);
    },

    filterF(item) {
      for (let i in this.filterFunctions) {
        if (!this.filterFunctions[i](item)) {
          return false;
        }
      }
      return true;
    },

    consultMetas(ruta, asign, arg) {
      // Make query for metaDatas
      dataService.fetch(ruta, { id: arg, noStore: true }).then((res) => {
        this[asign] = res;
      });
    },

    onResponsiveInverted() {
      if (window.innerWidth < 768) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
  },
  mounted() {
    this.registerFilter((element) => {
      return !this.highwayS ? true : element.highway === this.highwayS;
    });
    this.registerFilter((element) => {
      return !this.stateS ? true : element.state === this.stateS;
    });
    // get metadatas
    this.consultMetas("highway", "mHighways");
    this.consultMetas("common/states", "mStates");

    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  watch: {
    datasOut: function () {
      this.$emit("filtered", this.datasOut);
    },
  },
  computed: {
    datasOut: function () {
      return this.datasIn.filter(this.filterF);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/Catalogs/Camp/Filter.vue